var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "GenerateDoc" },
    [
      _vm.isMessage ? _c("create-message") : _vm._e(),
      _vm._v(" "),
      !_vm.isMessage && _vm.isHowDoc
        ? _c("show-document", { attrs: { item: _vm.form } })
        : !_vm.isMessage
        ? _c(
            "form",
            { staticClass: "gen-form gen-doc-form", attrs: { action: "" } },
            [
              _c("div", { staticClass: "gen-fieldset__item" }, [
                _c("label", [_vm._v("Title")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.title,
                      expression: "form.title",
                    },
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.title },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "title", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "gen-fieldset__item" }, [
                _c("div", { staticClass: "gen-select-container " }, [
                  _c("label", [_vm._v("Format")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui-ddbox ui-ddbox-select" }, [
                    _c("button", { staticClass: "ui-ddbtn" }, [
                      _c("span", { staticClass: "ui-ddbtnvalue" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.form.type) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-caret-down",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ui-ddbody" }, [
                      _c(
                        "div",
                        { staticClass: "ui-ddsection ui-assignedtoList" },
                        [
                          _c("ul", [
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.changeFormat("PDF")
                                  },
                                },
                              },
                              [_vm._v("PDF")]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "gen-fieldset__item" }, [
                _c("div", { staticClass: "gen-select-container " }, [
                  _c("label", [_vm._v("Background img")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui-ddbox ui-ddbox-select" }, [
                    _c("button", { staticClass: "ui-ddbtn" }, [
                      _c("span", { staticClass: "ui-ddbtnvalue" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.form.background) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-caret-down",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ui-ddbody" }, [
                      _c(
                        "div",
                        { staticClass: "ui-ddsection ui-assignedtoList" },
                        [
                          _c("ul", [
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.changeBackground(
                                      _vm.form.background
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.form.background) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "gen-fieldset__item" }, [
                _c("div", { staticClass: "gen-select-container" }, [
                  _c("label", [_vm._v("Text preset")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui-ddbox ui-ddbox-select" }, [
                    _c("button", { staticClass: "ui-ddbtn" }, [
                      _c("span", { staticClass: "ui-ddbtnvalue" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.form.preset) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-caret-down",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ui-ddbody" }, [
                      _c(
                        "div",
                        { staticClass: "ui-ddsection ui-assignedtoList" },
                        [
                          _c(
                            "ul",
                            _vm._l(_vm.docTexts, function (item, index) {
                              return _c("li", { key: index }, [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.changePreset(item)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "gen-fieldset__item full-input" }, [
                _c("label", [_vm._v("Notes")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.comments,
                      expression: "form.comments",
                    },
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.comments },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "comments", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "full-input drop-block" },
                [
                  _c("ckeditor", {
                    attrs: { editor: _vm.editor },
                    model: {
                      value: _vm.form.body,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "body", $$v)
                      },
                      expression: "form.body",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { ref: "tagsDropdown", staticClass: "drop-wrapper" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "drop-btn",
                          on: {
                            click: function ($event) {
                              _vm.isShowTags = !_vm.isShowTags
                            },
                          },
                        },
                        [
                          _vm._v("Tags\n          "),
                          _c("img", {
                            attrs: { src: "/img/drop-down.png", alt: "" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isShowTags
                        ? _c(
                            "ul",
                            { staticClass: "drop-down" },
                            _vm._l(_vm.tags, function (tag, index) {
                              return _c(
                                "li",
                                { key: index, staticClass: "drop-title" },
                                [
                                  _c("span", [_vm._v(_vm._s(tag.name))]),
                                  _vm._v(" "),
                                  tag.items.length
                                    ? _c(
                                        "ul",
                                        _vm._l(
                                          tag.items,
                                          function (item, index) {
                                            return _c("li", { key: index }, [
                                              _c(
                                                "span",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setEditorTag(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(_vm._s(item.label))]
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "button-holder" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.save()
                      },
                    },
                  },
                  [_vm._v("Save")]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("span", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }